import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const DIRECT_DEBIT: PaymentMethod = {
    id: PAYMENT_METHOD_ID.DirectDebit,
    name: 'directdebit'
};
